import React, { useCallback } from 'react';
import { Button, Spin, Space, ButtonProps } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';

interface FormActionsProps {
  editMode?: boolean;
  submitting?: boolean;
  getFormRef: () => any;
  submitIcon?: JSX.Element;
  submitText?: string;
  resetBtnText?: string;
  onReset: () => any;
  onSubmit: (v?: any) => any;
  disabled?: boolean;
  stepForm: boolean;
  buttonSize?: ButtonProps['size'];
}

export default function FormActions(props: FormActionsProps) {
  const {
    editMode = false,
    submitting = false,
    disabled = false,
    buttonSize = 'large',
    // resetBtnText = 'Reset',
    getFormRef,
    submitIcon,
    submitText,
    // onReset,
    onSubmit,
    stepForm,
  } = props;

  // const handleReset = useCallback(() => {
  //   if (stepForm) {
  //     const stepsRef = getFormRef().current;
  //     if (onReset) onReset();
  //     return stepsRef.stepFormRefs.map((ref: any) => ref.current?.resetFields());
  //   }
  //   if (onReset) return onReset();
  //   return getFormRef().current.resetFields();
  // }, [getFormRef, onReset, stepForm]);

  // const handleStepReset = useCallback(() => {
  //   const stepsRef = getFormRef().current;
  //   const { currentStep } = stepsRef.state;
  //   const currentReset = stepsRef.props.steps[currentStep].reset;
  //   if (currentReset) currentReset();
  //   stepsRef.stepFormRefs[currentStep].current?.resetFields();
  // }, [getFormRef]);

  const handleSubmit = useCallback(async () => {
    if (stepForm) {
      if (!onSubmit) throw new Error('onSubmit is required in FormActions for step form');

      const res = await getFormRef().current.validateForms();
      const data = {};
      let errors: any[] = [];

      res.forEach((stepResult: any) => {
        if (stepResult.status === 'fulfilled') {
          Object.assign(data, stepResult.value);
        }
        else {
          Object.assign(data, stepResult.reason.values);
          errors = errors.concat(stepResult.reason.errorFields);
        }
      });
      return onSubmit({ data, errors });
    }

    if (onSubmit) return onSubmit();
    return null;
  }, [getFormRef, onSubmit, stepForm]);

  return (
    <Space size="middle">
      {/* {stepForm ? (
        <Button
          type="primary"
          htmlType="reset"
          size={buttonSize}
          danger
          onClick={handleStepReset}
          icon={<ReloadOutlined />}
          disabled={disabled || submitting}
        >
          {resetBtnText}
        </Button>
      ) : null}

      <Button
        type="primary"
        htmlType="reset"
        size={buttonSize}
        danger
        onClick={handleReset}
        icon={<ReloadOutlined />}
        disabled={disabled || submitting}
      >
        {resetBtnText} {stepForm && 'All'}
      </Button> */}

      <Button
        type="primary"
        htmlType="submit"
        size={buttonSize}
        onClick={handleSubmit}
        icon={submitIcon || (editMode ? <EditOutlined /> : <PlusOutlined />)}
        disabled={disabled || submitting}
      >
        {submitText || (editMode ? 'Update' : 'Create')}
      </Button>

      {submitting && <Spin />}
    </Space>
  );
}
